import { render, staticRenderFns } from "./EduProgramSetting.vue?vue&type=template&id=4f342fc8&"
import script from "./EduProgramSetting.vue?vue&type=script&lang=js&"
export * from "./EduProgramSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports